import { render, staticRenderFns } from "./ITRDependentCard.vue?vue&type=template&id=b497e97e&scoped=true&"
import script from "./ITRDependentCard.vue?vue&type=script&lang=ts&"
export * from "./ITRDependentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b497e97e",
  null
  
)

export default component.exports